<template>
    <div>
        <app-template>
            <div class="max-w-2xl mx-auto py-16">

                <div class="bg-white border rounded-lg p-8 text-center space-y-6">

                    <!-- Icon -->
                    <div class="flex justify-center">
                        <div class="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                            <i class="fas fa-check text-green-600 text-3xl"></i>
                        </div>
                    </div>

                    <!-- Title -->
                    <div>
                        <h1 class="text-2xl font-bold text-gray-800">
                            Paiement confirmé 🎉
                        </h1>
                        <p class="text-gray-500 mt-2">
                            Votre pack de SMS a bien été acheté.
                        </p>
                    </div>

                    <!-- Info -->
                    <div class="bg-blue-50 border-l-4 border-blue-500 p-4 text-sm text-blue-900 text-left rounded">
                        Les crédits SMS sont ajoutés automatiquement à votre compte.<br />
                        Cela peut prendre quelques secondes le temps de la synchronisation.
                    </div>

                    <!-- Actions -->
                    <div class="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                        <a
                            href="/app/parametres/sms"
                            class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium">
                            Voir mes crédits SMS
                        </a>

                        <a
                            href="/app"
                            class="bg-gray-100 hover:bg-gray-200 text-gray-800 px-6 py-2 rounded-lg font-medium">
                            Retour au tableau de bord
                        </a>
                    </div>

                </div>

            </div>
        </app-template>
    </div>
</template>

<script>
export default {
    name: 'SmsPurchaseSuccess',
}
</script>

<style lang="scss" scoped>
</style>
